import { ARFiltersArgs } from './ARFilters';

export const checkObligatoryFilters = (filters: ARFiltersArgs) => {
  return (
    (filters.customers?.length ?? 0) > 0 ||
    (filters.contracts?.length ?? 0) > 0 ||
    (filters.dates?.length ?? 0) > 0
  );
};
